import React, { useEffect } from "react";
import InstructionPage from "../../../../shared/pages/Instruction/InstructionPage";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  fetchExamQuestionsListRequest,
} from "../../../../redux/exam/examSlice";
import useAppHooks from "../../../../shared/hooks/useAppHooks";
import "./ExamInstructionPage.css";

// ✅ Convert duration minutes → HH:MM:SS format
function formatTime(totalMinutes) {
  let totalSeconds = totalMinutes * 60;

  let hrs = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  let mins = Math.floor(totalSeconds / 60);
  let secs = totalSeconds % 60;

  return (
    String(hrs).padStart(2, "0") +
    ":" +
    String(mins).padStart(2, "0") +
    ":" +
    String(secs).padStart(2, "0")
  );
}

const ExamInstructionPage = () => {
  const dispatch = useDispatch();
  const { history } = useAppHooks();

  const { instructions, loading, error, testType, testDetails } = useSelector(
    (state) => state.examSlice
  );

  // Handle test start
  const handleStartTest = () => {
    dispatch(
      fetchExamQuestionsListRequest({
        paperId: testDetails?.paper_id,
        paperType: testType?.id,
      })
    );
    history.push("/test");
  };

  // Fetch instructions initially
  useEffect(() => {
    if (testType && testDetails) {
      dispatch(
        fetchExamInstructionRequest({
          paperId: testDetails?.paper_id,
          paperType: testType?.id,
        })
      );
    }
  }, [dispatch]);

  const header = <h2>Test Instructions</h2>;

  // ------------------- DURATION FIX -------------------
  // Always use duration_mins (API dates are wrong)
  let finalDuration = "00:00:00";

  if (instructions?.duration_mins) {
    finalDuration = formatTime(Number(instructions.duration_mins));
  }
  // ----------------------------------------------------

  const body = (
    <>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}

      <h3>General Instruction</h3>

      {!loading && !error && instructions && (
        <div className="instruction-content">
          {/* LEFT SIDE */}
          <div className="instruction-left">
            <div className="instruction-details">
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    instructions.instructions_html ||
                    instructions.test_instruction_eng,
                }}
              />
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="instruction-right">
            <div className="test-card">
              <div className="test-card-header">
                <img
                  src={instructions.paper_icon}
                  alt="Test Icon"
                  className="card-icon"
                />
                <div>
                  <h4>{instructions.paper_name}</h4>
                  <p className="test-series">{instructions.target}</p>
                </div>
              </div>

              <div className="test-card-body">
                <p>
                  <strong>Duration</strong>{" "}
                  <span>{finalDuration}</span>
                </p>

                <p>
                  <strong>Total Questions</strong>{" "}
                  <span>{instructions.total_questions} Questions</span>
                </p>
              </div>
            </div>

            <button className="start-test-btn" onClick={handleStartTest}>
              Start Test
            </button>
          </div>
        </div>
      )}
    </>
  );

  return <InstructionPage header={header} body={body} />;
};

export default ExamInstructionPage;
